import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useUser} from '@/logged/features/user';
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {NavigationTab} from '../aside-menu.types';
    import NavigationTabItem from './NavigationTabItem.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  setup(__props) {

    const userStore = useUser();
    const {selectedCountry, selectedLanguage} = storeToRefs(userStore);

    const navigationTabProps = computed<NavigationTab>(() => ({
        id: 'Language',
        title: selectedLanguage.value.name.toUpperCase(),
        icons: {
            mainIcon: selectedCountry.value.icon,
            canBeActive: false,
        },
        action: () => {
            // @ts-ignore
            // $ not usable in script setup
            // eslint-disable-next-line no-undef
            jQuery('#languageSelectorModal').modal('show');
        },
    }));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigationTabItem, {
    tab: _unref(navigationTabProps),
    "hide-collapse-on-full": true
  }, null, 8, ["tab"]))
}
}

})